var DetailTableDuplCheckController = (function () {
    function DetailTableDuplCheckController(topic, settings, socket, $injector, env, $timeout, $stateParams, $scope) {
        this.topic = topic;
        this.settings = settings;
        this.socket = socket;
        this.$injector = $injector;
        this.env = env;
        this.$timeout = $timeout;
        this.$stateParams = $stateParams;
        this.$scope = $scope;
        this.dataSources = ['dc_mysa', 'dc_sc'];
        this.comp = ['dc_mysa', 'dc_sc'];
        this.updateArray = ['dc'];
        this.lock = true;
        this.requiredCountrySearch = true;
        this.checkData = _.get(this, 'topic.checksData.result');
        this.OPP_VERSION_5 = 5;
        this.tableName = 'Automatic Duplicate Check';
        this.dc = {
            ds: 'GPP',
            countrySelected: [],
            usStatesAll: [],
            fuzzySearch: '',
            opp: '',
            countryLine: [],
            alterBrandFam: [],
            createDate: 0,
            decisionDate: 0
        };
        this.visible = false;
        this.expand = false;
        this.stopSubmit = false;
        this.filterDisplay = false;
    }
    DetailTableDuplCheckController.prototype.toggleFilter = function () {
        this.filterDisplay = !this.filterDisplay;
    };
    // For EU/NA vs AP different options to display
    DetailTableDuplCheckController.prototype.$onInit = function () {
        this.usPicked = false;
        this.countryDecided = angular.isDefined(this.topic.country.imt);
    };
    DetailTableDuplCheckController.prototype.toggle = function () {
        this.visible = !this.visible;
    };
    // sends a broadcast to expand or colapse the table sections
    DetailTableDuplCheckController.prototype.expandAll = function (value) {
        this.$injector.get('$rootScope').$broadcast('expand.all.dc', value);
        this.expand = value;
    };
    DetailTableDuplCheckController.prototype.updateBant = function () {
        this.topic.setTempFromTopicPart(this.comp);
        var upData = {
            id: this.topic.topic._id,
            data: {
                'dc.0.bant': {
                    add: true,
                    data: this.topic.temp.dc[0].bant
                }
            },
            type: ['dc', 'complcl3']
        };
        this.topic.updateServerTopic('couchUpdate', upData, false);
    };
    DetailTableDuplCheckController.prototype.reload = function () {
        console.info('$detail.table.duplcheck (reload) => reloading');
        this.topic.loaded.gpp_valid = true;
        this.socket.emit('module', {
            module: {
                application: 'dmt',
                function: 'validation',
                script: '/detail/validation/validation',
                opp: this.topic.topic.opp,
                unid: this.topic.topic._id,
                token: this.env.user.token
            }
        });
    };
    DetailTableDuplCheckController.prototype.pushAlterBfItem = function () {
        var _this = this;
        var dupli = false;
        angular.forEach(this.dc.alterBrandFam, function (iter) {
            if (iter === _this.alterToBeInserted) {
                dupli = true;
            }
        });
        if (!dupli) {
            this.dc.alterBrandFam.push(this.alterToBeInserted);
        }
        this.alterToBeInserted = '';
    };
    DetailTableDuplCheckController.prototype.clearAlterBFList = function () {
        this.dc.alterBrandFam = [];
    };
    DetailTableDuplCheckController.prototype.countryChange = function () {
        var _this = this;
        this.usPicked = false;
        angular.forEach(this.dc.countrySelected, function (country) {
            if (country.short === 'US') {
                _this.usPicked = true;
            }
        });
    };
    DetailTableDuplCheckController.prototype.hasCheckRun = function (type) {
        if (this.topic.topic.dc && this.topic.topic.dc.results) {
            for (var _i = 0, _a = this.topic.topic.dc.results; _i < _a.length; _i++) {
                var oneRes = _a[_i];
                if (oneRes.ds === type && !oneRes.error) {
                    return true;
                }
            }
        }
        return false;
    };
    DetailTableDuplCheckController.prototype.changeEditMode = function (action) {
        if (action === 'save') {
            var data = {
                id: this.topic.topic._id,
                data: (_a = {},
                    _a['dc'] = {
                        add: true,
                        data: this.topic.temp.dc
                    },
                    _a['complcl3'] = {
                        add: true,
                        data: this.topic.temp.complcl3
                    },
                    _a
                ),
                type: ['dc', 'complcl3']
            };
            this.topic.updateServerTopic('couchUpdate', data, true);
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
        else if (action === 'edit') {
            this.edit.editMode = this.topic.setTempFromTopicPart(this.comp);
        }
        else {
            this.topic.temp[this.comp] = this.topic.topic[this.comp]; //Reset to original value
            this.edit.editMode = this.topic.cancelEdit(this.comp);
        }
        var _a;
    };
    DetailTableDuplCheckController.$inject = ['topic', 'settings', 'socket', '$injector', 'env', '$timeout', '$stateParams', '$scope', '_'];
    return DetailTableDuplCheckController;
}());
var DetailTableDuplCheckComponent = (function () {
    function DetailTableDuplCheckComponent() {
        this.templateUrl = 'detail-table-duplcheck-4x4.html';
        this.controllerAs = 'vm';
        this.controller = DetailTableDuplCheckController;
    }
    return DetailTableDuplCheckComponent;
}());
angular
    .module('application')
    .component('detailTableDuplCheckAutomatic', new DetailTableDuplCheckComponent());

//# sourceMappingURL=detail.table.duplcheck.automatic.component.js.map
